import { useEffect, useState } from "react";
import Container from "../../UI/Container";
import { Divider, Grid, Paper, Typography } from "@mui/material";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import {
  findCatracaRegistroContadorByAno,
  findCatracaRegistroContadorByDiaDoMes,
  findCatracaRegistroContadorByMes,
} from "../api-catraca-registro";
import Button from "../../UI/Button";
import { Link } from "react-router";
import dayjs from "dayjs";
import TextFieldDate from "../../UI/TextFieldDate";
import Select from "../../UI/Select";
import CatracaRegistroContadorView from "./CatracaRegistroContaodorView";
import session from "../../../SessionHandler/session-helper";

const CatracaRegistroContadorContainer = () => {
  const [dateSelected, setDateSelected] = useState(new Date());
  const [listCRCDia, setListCRCDia] = useState([]);
  const [listCRCMes, setListCRCMes] = useState([]);
  const [listCRCAno, setListCRCAno] = useState([]);
  const [isLoadingPorDiaDoMes, setIsLoadingPorDiaDoMes] = useState(false);
  const [isLoadingPorMes, setIsLoadingPorMes] = useState(false);
  const [isLoadingPorAno, setIsLoadingPorAno] = useState(false);
  const listMes = [
    { value: 1, description: "Janeiro" },
    { value: 2, description: "Fevereiro" },
    { value: 3, description: "Março" },
    { value: 4, description: "Abril" },
    { value: 5, description: "Maio" },
    { value: 6, description: "Junho" },
    { value: 7, description: "Julho" },
    { value: 8, description: "Agosto" },
    { value: 9, description: "Setembro" },
    { value: 10, description: "Outubro" },
    { value: 11, description: "Novembro" },
    { value: 12, description: "Dezembro" },
  ];
  const [mes, setMes] = useState(new Date().getMonth() + 1);

  const handleDataChange = (data) => {
    setDateSelected(new Date(dayjs(data)));
  };

  useEffect(() => {
    fetchDataContadorPorDia();
    fetchDataContadorPorMes();
    fetchDataContadorPorAno();
    // eslint-disable-next-line
  }, []);

  const fetchDataContadorPorDia = () => {
    setIsLoadingPorDiaDoMes(true);
    findCatracaRegistroContadorByDiaDoMes(
      dateSelected.getFullYear(),
      dateSelected.getMonth() + 1,
      dateSelected.getDate()
    ).then((data) => {
      if (data) {
        if (data.error) {
          errorMessage(data.message);
        } else {
          setListCRCDia(data);
        }
      }
      setIsLoadingPorDiaDoMes(false);
    });
  };

  const fetchDataContadorPorMes = () => {
    setIsLoadingPorMes(true);
    findCatracaRegistroContadorByMes(mes).then((data) => {
      if (data) {
        if (data.error) {
          errorMessage(data.message);
        } else {
          setListCRCMes(data);
        }
      }
      setIsLoadingPorMes(false);
    });
  };

  const fetchDataContadorPorAno = () => {
    setIsLoadingPorAno(true);
    findCatracaRegistroContadorByAno().then((data) => {
      if (data) {
        if (data.error) {
          errorMessage(data.message);
        } else {
          setListCRCAno(data);
        }
      }
      setIsLoadingPorAno(false);
    });
  };

  const onChangeMes = (event) => {
    setMes(event.target.value);
  };

  return (
    <Container component={Paper}>
      <Grid container direction="column" spacing={3}>
        <Grid>
          <Typography variant="h5">Monitor de Acesso Contador</Typography>
        </Grid>
        <Grid>
          <Button color="secondary" component={Link} to="/monitor-acesso-menu">
            Voltar para o Menu
          </Button>
        </Grid>

        <Grid>
          <Divider />
        </Grid>
        <Grid>
          <p>Por dia do mês</p>
        </Grid>
        <Grid>
          <TextFieldDate
            label="Data"
            value={dateSelected ? dateSelected : null}
            onChange={handleDataChange}
          />
        </Grid>
        <Grid>
          <Button onClick={fetchDataContadorPorDia}>Aplicar Data</Button>
        </Grid>
        <CatracaRegistroContadorView
          isLoading={isLoadingPorDiaDoMes}
          listCRC={listCRCDia}
        />
        <Grid>
          <Divider />
        </Grid>
        <Grid>
          <p>Por mês</p>
        </Grid>
        <Grid size={3}>
          <Select
            label="Mês"
            value={mes}
            list={listMes}
            onChange={onChangeMes}
          />
        </Grid>
        <Grid>
          <Button onClick={fetchDataContadorPorMes}>Aplicar Mês</Button>
        </Grid>
        <CatracaRegistroContadorView
          isLoading={isLoadingPorMes}
          listCRC={listCRCMes}
        />
        <Grid>
          <Divider />
        </Grid>
        <Grid>
          <p>Por Ano - {session.getAnoLetivo()}</p>
        </Grid>
        <CatracaRegistroContadorView
          isLoading={isLoadingPorAno}
          listCRC={listCRCAno}
        />
      </Grid>
    </Container>
  );
};

export default CatracaRegistroContadorContainer;
